export default __webpack_public_path__ + "images/mf-2d96a80bd05aca4ef7119716fad0fe64.svg";